import { VorgangProzessSchrittStatus } from '@core/domain';

interface AntwortSchritt {
  initialPayload: unknown;
  successPayload?: unknown;
  status: string;
}

export function getArchivierungBeschreibung(schritt: AntwortSchritt): string {
  const initialPayload = schritt.initialPayload as {
    archivierungAktiv?: boolean;
  } | null;
  const successPayload = schritt.successPayload as {
    archivierungErgebnis?: 'ERFOLGREICH' | 'UEBERSPRUNGEN' | 'WIEDERHOLUNG';
  } | null;

  if (initialPayload?.archivierungAktiv === undefined) {
    return schritt.status === VorgangProzessSchrittStatus.FEHLER
      ? 'Archivierung fehlgeschlagen; Archivierungsentscheidung nicht erfasst.'
      : 'Archivierungsentscheidung für diesen Lauf nicht erfasst.';
  }
  if (successPayload?.archivierungErgebnis === 'UEBERSPRUNGEN') {
    return 'Archivierung laut Dokumenttyp-Konfiguration übersprungen.';
  }
  if (successPayload?.archivierungErgebnis === 'ERFOLGREICH') {
    return 'Archivierung vorgesehen und erfolgreich durchgeführt.';
  }
  if (successPayload?.archivierungErgebnis === 'WIEDERHOLUNG') {
    return 'Archivierung wird automatisch erneut versucht.';
  }
  if (schritt.status === VorgangProzessSchrittStatus.FEHLER) {
    return initialPayload.archivierungAktiv
      ? 'Archivierung vorgesehen; Verarbeitung fehlgeschlagen.'
      : 'Archivierung deaktiviert; Verarbeitung fehlgeschlagen.';
  }
  return initialPayload.archivierungAktiv
    ? 'Archivierung vorgesehen; Abschluss steht aus.'
    : 'Archivierung deaktiviert; Überspringen steht aus.';
}
